export const heading = "h1vyifd";
export const list = "lf1heao";
export const content = "cywll4y";
export const bodyText = "b1jyew54";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");